import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./translations/en.json";
import translationFR from "./translations/fr.json";
import translationDE from "./translations/de.json";
import translationNL from "./translations/nl.json";
import translationPT from "./translations/pt.json";
import translationES from "./translations/es.json";
import translationIT from "./translations/it.json";
import translationNO from "./translations/no.json";
import translationSV from "./translations/sv.json";
import translationFI from "./translations/fi.json";
import translationRU from "./translations/ru.json";
import translationPL from "./translations/pl.json";
import translationHU from "./translations/hu.json";
import translationHR from "./translations/hr.json";
import translationLT from "./translations/lt.json";
import translationCS from "./translations/cs.json";
import translationEL from "./translations/el.json";
import translationJA from "./translations/ja.json";
import translationTR from "./translations/tr.json";
import translationZHHANT from "./translations/zh-Hant.json";
import translationZHHANS from "./translations/zh-Hans.json";

// the translations
const resources = {
  "en": {
    translation: translationEN
  },
  "fr": {
    translation: translationFR
  },
  "de": {
    translation: translationDE
  },
  "nl": {
    translation: translationNL
  },
  "pt": {
    translation: translationPT
  },
  "es": {
    translation: translationES
  },
  "it": {
    translation: translationIT
  },
  "no": {
    translation: translationNO
  },
  "sv": {
    translation: translationSV
  },
  "fi": {
    translation: translationFI
  },
  "ru": {
    translation: translationRU
  },
  "pl": {
    translation: translationPL
  },
  "hu": {
    translation: translationHU
  },
  "hr": {
    translation: translationHR
  },
  "lt": {
    translation: translationLT
  },
  "cs": {
    translation: translationCS
  },
  "el": {
    translation: translationEL
  },
  "ja": {
    translation: translationJA
  },
  "tr": {
    translation: translationTR
  },
  "zh-Hant": {
    translation: translationZHHANT
  },
  "zh-Hans": {
    translation: translationZHHANS
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    keySeparator: ".", // to support nested translations
    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

export default i18n;
